
/* ============
 * Vuex Store
 * ============
 *
 * The store of the application.
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vue from 'vue';
import Vuex from 'vuex';
//import createLogger from 'vuex';

// Modules
import coreui from './modules/coreui';
import auth from './modules/auth';
import user from './modules/user';
import member from './modules/member';
import organization from './modules/organization';
import department from './modules/department';
import group from './modules/group';
import deptMember from './modules/deptMember';
import groupDeptMember from './modules/groupMember';
import channel from './modules/channel';
import asset from './modules/asset';
import chnlWhitelist from "./modules/chnlWhitelist";
import chnlOrgWhitelist from "./modules/chnlOrgWhitelist";
import recshare from "./modules/recshare";
import recshareMember from "./modules/recshareMember";


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    coreui,
    auth,
    organization,
    department,
    user,
    member,
    group,
    deptMember,
    groupDeptMember,
    channel,
    asset,
    chnlWhitelist,
    chnlOrgWhitelist,
    recshare,
    recshareMember,
  },

  /**
   * If strict mode should be enabled.
   */
  strict: debug,

  /**
   * Plugins used in the store.
   */
  //plugins: debug ? [createLogger()] : [],
});
